export const PolicyPath = {
  PRIVACY: '/legal/privacy',
  TIKTOK_PRIVACY: '/legal/tiktok-privacy',
  TERMS_OF_SERVICE: '/legal/terms-of-service',
  SUPPLEMENTAL_TERMS_OF_USE: '/legal/supplemental-terms-of-use',
  TERMS_OF_CREATOR_REFERRAL: '/legal/terms-of-creator-referral', // no
  TERMS_OF_HYPE_SQUAD: '/legal/terms-of-hype-squad', // no
  INTELLECTUAL_PROPERTY: '/legal/intellectual-property',
  ACTIVITY_NOTES: '/activity-notes', // only jp
  GOODS_DISCLAIMER: '/goods-disclaimer', // only jp
  USER_GROUP_PRIVACY: '/user-group-privacy', // only jp
  COMMUNITY_GUIDELINE: '/community-guideline',
  COPYRIGHT: '/copyright', // only jp
  OPEN_SOURCE_NOTICE_ANDROID: '/legal/open-source-notice-android',
  OPEN_SOURCE_NOTICE_IOS: '/legal/open-source-notice-ios',
  AMPLIFY_PROGRAM: '/amplify-program-term', // no
  COOKIES_POLICY: '/legal/cookies-policy',
  LAW_ENFORCEMENT_GUIDELINE: '/legal/law-enforcement-guideline',
  LAW_ENFORCEMENT_GUIDELINE_FORM: '/legal/law-enforcement-guideline/form',
  AVMSD: '/legal/avmsd',
  CONSUMER_HEALTH_DATA_PRIVACY: '/legal/consumer-health-data-privacy',
  TIKTOK_CONTENT_SHARING_AUTHORIZATION_STATEMENT: '/legal/tiktok-content-sharing-authorization-statement',
  TIKTOK_CONTENT_SHARING_AUTHORIZATION_STATEMENT_IN_LEMON8:
    '/legal/tiktok-content-sharing-authorization-statement-in-lemon8',
};
